export const VOUCHER_NAME_PATTERN = /^[A-Za-z0-9_-]+$/;
export const VOUCHER_NAME_PATTERN_MESSAGE = 'Use letters, digits, underscores, and dashes only';
export const CLONE_VOUCHER_NAME_PATTERN = /^[A-Za-z0-9_ -]+$/;
export const CLONE_VOUCHER_NAME_PATTERN_MESSAGE = 'Use letters, digits, underscores, dashes, and spaces only';

export function validateRequiredVoucherName(
  value: string,
  requiredMessage = 'Voucher name is required',
): true | string {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return requiredMessage;
  }
  if (!VOUCHER_NAME_PATTERN.test(trimmedValue)) {
    return VOUCHER_NAME_PATTERN_MESSAGE;
  }
  return true;
}

export function getVoucherNamePatternError(value: string | undefined): string | null {
  if (!value) {
    return null;
  }
  if (!VOUCHER_NAME_PATTERN.test(value)) {
    return `Name (${value}) ${VOUCHER_NAME_PATTERN_MESSAGE.toLowerCase()}`;
  }
  return null;
}

export function validateRequiredCloneVoucherName(
  value: string,
  requiredMessage = 'Enter a new voucher name.',
): true | string {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return requiredMessage;
  }
  if (!CLONE_VOUCHER_NAME_PATTERN.test(trimmedValue)) {
    return CLONE_VOUCHER_NAME_PATTERN_MESSAGE;
  }
  return true;
}
